import type { ThemeConfig } from "antd";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

export const responsiveLabelStyle = () => {
  const screens = useBreakpoint();
  const isLargeScreen = screens.xxl;

  return {
    width: isLargeScreen ? "240px" : "180px",
    verticalAlign: "top",
  };
};

export const adminTheme: ThemeConfig = {
  components: {
    Form: {
      colorPrimary: "rgb(36,42,51)",
      colorBorder: "rgb(231,231,231)",
      margin: 20,
    },
    Breadcrumb: {
      fontSize: 22,
    },
    Button: {
      fontWeight: 500,
      borderRadius: 20,
      borderRadiusSM: 20,
      contentFontSizeSM: 13,
      paddingInline: 18,
      paddingInlineSM: 18,
      controlHeightSM: 32,
      controlHeight: 38,
      defaultShadow: "none",
      colorPrimary: "rgb(255,79,20)",
      colorLink: "rgb(255,79,20)",
      colorInfo: "rgb(255,79,20)",
      defaultBorderColor: "#000000",
    },
    Checkbox: {
      controlInteractiveSize: 20,
      colorPrimary: "#444",
      colorPrimaryHover: "#999",
      paddingXS: 15,
      colorText: "#444",
      borderRadiusSM: 4,
    },
    Radio: {
      radioSize: 20,
      colorPrimary: "#444",
      paddingXS: 15,
    },
    Input: {
      colorText: "rgba(0,0,0,0.75)",
      borderRadius: 11,
      borderRadiusSM: 21,
      controlHeight: 42,
      controlHeightSM: 36,
      paddingXS: 15,
      colorBorder: "#e9e9e9",
    },
    Pagination: {
      borderRadius: 20,
      borderRadiusLG: 98,
      borderRadiusSM: 12,
    },
    Select: {
      borderRadius: 11,
      borderRadiusSM: 11,
      controlHeight: 42,
      controlHeightSM: 36,
      paddingXS: 15,
      colorBorder: "#e9e9e9",
    },
    Transfer: {
      borderRadiusLG: 12,
    },
    TreeSelect: {
      borderRadius: 6,
    },
    Menu: {
      activeBarBorderWidth: 0,
      itemBorderRadius: 26,
      borderRadius: 8,
      borderRadiusLG: 92,
      horizontalItemHoverColor: "#e4e4e4",
      horizontalItemSelectedColor: "#f4f4f4",
      itemSelectedColor: "#000000",
      itemSelectedBg: "#f4f4f4",
      itemActiveBg: "#d4d4d4",
      subMenuItemBg: "transparent",
      subMenuItemSelectedColor: "#000000",
    },
    DatePicker: {
      paddingSM: 14,
      paddingXXS: 3,
      marginXXS: 8,
      padding: 12,
      borderRadius: 11,
      borderRadiusSM: 11,
      controlHeight: 42,
      controlHeightSM: 36,
      paddingXS: 6,
      paddingInlineSM: 15,
      cellHeight: 30,
      cellWidth: 40,
      colorBorder: "#e9e9e9",
    },
    InputNumber: {
      borderRadius: 11,
      borderRadiusSM: 21,
      controlHeight: 42,
      controlHeightSM: 36,
      paddingXS: 15,
      controlWidth: "100%",
      handleWidth: 22,
      colorBorder: "#e9e9e9",
    },
    Mentions: {
      borderRadius: 6,
      controlHeight: 40,
      borderRadiusLG: 12,
    },
    Rate: {
      starColor: "rgb(250,173,20)",
    },
    Slider: {
      colorPrimaryBorderHover: "rgb(255,79,20)",
      handleSize: 12,
      handleSizeHover: 14,
      controlHeight: 40,
    },
    Switch: {
      handleSize: 20,
      trackHeight: 24,
      trackMinWidth: 48,
    },
    Upload: {
      borderRadiusLG: 12,
    },
    Card: {
      borderRadiusLG: 16,
      headerPadding: "22px 0 42px",
      bodyPadding: "24px 42px 20px",
      headerFontSize: 18,
      headerHeight: 70,
      colorBorderSecondary: "#f5f5f5",
    },
    Segmented: {
      borderRadius: 6,
    },
    Tabs: {
      borderRadius: 6,
      borderRadiusLG: 12,
      cardGutter: 8,
      horizontalItemPadding: "8px 18px",
      cardPadding: "8px 18px",
      itemSelectedColor: "#000000",
      itemHoverColor: "#000000",
      colorText: "#5f6368",
      inkBarColor: "#000000",
      cardBg: "transparent",
      colorBorder: "transparent",
    },
    Tooltip: {
      borderRadius: 6,
    },
    Tree: {
      borderRadius: 6,
    },
    Alert: {
      borderRadiusLG: 12,
      defaultPadding: "12px 12px",
      withDescriptionPadding: "20px 16px",
    },
    Message: {
      borderRadiusLG: 12,
      boxShadow:
        "0 3px 6px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
    },
    Modal: {
      borderRadiusLG: 16,
      borderRadiusSM: 3,
      boxShadow:
        "0 3px 6px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
    },
    Notification: {
      borderRadiusLG: 12,
      borderRadiusSM: 3,
      boxShadow:
        "0 3px 10px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
      paddingContentHorizontalLG: 24,
      paddingMD: 24,
      controlHeightLG: 42,
      margin: 25,
    },
    Progress: {
      defaultColor: "rgb(255,79,20)",
    },
    Spin: {
      dotSizeLG: 24,
      dotSize: 24,
    },
    Popconfirm: {
      algorithm: true,
    },
    Dropdown: {
      borderRadiusLG: 12,
    },
    Cascader: {
      borderRadiusSM: 6,
    },
    Popover: {
      borderRadiusLG: 12,
      boxShadowSecondary:
        "0 3px 10px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
    },
    Divider: {
      margin: 24,
      marginLG: 28,
      orientationMargin: 0.5,
    },
    Descriptions: {
      labelBg: "rgba(255,255,255,0.02)",
      colorSplit: "rgba(255,255,255,0.06)",
      padding: 8,
      paddingLG: 0,
    },
    Table: {
      headerBg: "#ffffff",
      bodySortBg: "#ffffff",
      colorBgContainer: "transparent",
      rowHoverBg: "#fafafb",
      cellPaddingBlock: 8,
      paddingXS: "8px 2px",
      borderColor: "#f8f8f8",
      fixedHeaderSortActiveBg: "#ffffff",
      headerSortActiveBg: "#f9f9f9",
      headerSortHoverBg: "#f9f9f9",
    },
    Layout: {
      zeroTriggerWidth: 30,
      triggerHeight: 26,
      headerHeight: 26,
    },
    Steps: {
      dotSize: 16,
    },
    Collapse: {
      headerBg: "#fff",
      colorBorder: "#e8e8e8",
    },
  },
  token: {
    colorPrimary: "#ff4f14",
    colorInfo: "#ff4f14",
    colorError: "#ce0000",
    colorSuccess: "#28a800",
    fontFamily: "'Inter', sans-serif",
    borderRadius: 12,
    fontSize: 14,
    wireframe: false,
  },
};
